import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "answers",
        object: "answer",
        header: [
            { text: "Nombre y Apellido", value: "fullname" },
            { text: "Opción", value: "option" },
            { text: "Fecha creación", value: "created_at" },
            { text: "Tiene spot", value: "has_spots" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
